import { render, staticRenderFns } from "./FormStatisticOrderChart.vue?vue&type=template&id=2c225960&"
import script from "./FormStatisticOrderChart.vue?vue&type=script&lang=js&"
export * from "./FormStatisticOrderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports